import { render, staticRenderFns } from "./MainEventWrapper.vue?vue&type=template&id=19af388c"
import script from "./MainEventWrapper.vue?vue&type=script&lang=js"
export * from "./MainEventWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports